import { ChangeEvent, useEffect,  useState } from 'react'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusInputText } from '@rhybus/form-controls'
import { RhyBusQandAInnerview } from '@rhybus/qanda'
import { getQnaData} from '../../services/qanda'
import { getQnaTags, qnaInnerViewFields, qnaPageConfig, qnaSearchFields } from '../../config/configuration'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'
export default function QA() {
  const [searchValue, setSearchValue] = useState('')
  const [qnaItems, setQnaItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getQnaData().then(setQnaItems).finally(() => setIsLoading(false))
  }, [])
  const [filteredItems, setFilteredItems] = useState(qnaItems)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  return (
    <main id="main-content">
    {isLoading && <PageOverlay />}
    <RhyBusPageHeader
      pageTitle={qnaPageConfig.pageTitle}
      badgeCount={filteredItems.length}
      pageHeaderIcon="icon-rb-question-thick"
      headerRightContent={
        <div className="d-flex align-items-center justify-content-end">
          <label htmlFor="qa-search" className="sr-only">Search questions and answers</label>
          <RhyBusInputText
            id="qa-search"
            type='search'
            iconRight={true}
            wrapperClassName='min-w-250'
            customIcon="icon-rb-search"
            placeholder={qnaPageConfig.searchPlaceholder}
            value={searchValue}
            onChange={handleChange}
          />
        </div>
      }
    />
    <div className='rb-innerview-pages'>
      <RhyBusQandAInnerview
        items={qnaItems}
        searchFields={qnaSearchFields}
        getTags={getQnaTags}
        innerViewFields={qnaInnerViewFields}
        searchText={searchValue}
        cardSize="lg"
        onFilteredItemsChange={(items: any) => setFilteredItems(items)}
      />
    </div>
  </main>
  )
}